var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointerMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 8.43665L0.856886 0.0528077C0.412531 -0.145947 -0.0727514 0.24554 0.00910349 0.739416L3.38269 21.5424C3.4704 22.0905 4.15447 22.2652 4.48189 21.8195L8.88451 15.7966C9.13008 15.4653 9.61536 15.4593 9.86093 15.7846L15.7252 23.5119C16.1462 24.066 16.918 24.1624 17.4559 23.7287L18.4265 22.9458C18.9644 22.5121 19.0579 21.7171 18.6369 21.163L12.7492 13.4055C12.4978 13.0743 12.6206 12.5864 13.0006 12.4298L19.6192 9.59907C20.122 9.38224 20.1279 8.65347 19.6309 8.43063L19.625 8.43665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerMedium);
export default __webpack_public_path__ + "static/media/pointer-medium.715dd2667cb11ade30c3e78b91f666ca.svg";
export { ForwardRef as ReactComponent };